import { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import ShortTextDisplay from './Display';

// TODO convert to use TextInputInline and TextControl

export default function LinkTextInline({
  value,
  field,
  entityId,
  onSubmit,
  ...others
}) {
  const [editing, setEditing] = useState(false);
  const [stagedValue, setStagedValue] = useState(value);
  useEffect(() => {
    setStagedValue(value);
  }, [value, editing]);
  return (
    <ShortTextDisplay
      field={field}
      entityId={entityId}
      editing={editing}
      onEditing={setEditing}
      value={editing ? stagedValue : value}
      onChange={setStagedValue}
      onSubmit={onSubmit}
      {...others}
    />
  );
}

LinkTextInline.propTypes = {
  value: PropTypes.string.isRequired,
};
